import React, { FC } from 'react';
import { QnadaReviewModeTabs } from '../../../../../constans/question-enums';
import { IReviewNavTabs } from '../questions-review-mode-container';

interface IProps {
  tabs: IReviewNavTabs[];
  selected: string;
  setSelected: (title: QnadaReviewModeTabs) => void;
  isMobile: boolean;
}

const QuestionsReviewModeNavTabs: FC<IProps> = ({ tabs, selected, setSelected, isMobile }): JSX.Element | null => {
  if(isMobile) {
    return (
      <>
        {tabs.map((tab: IReviewNavTabs) => {
          const active = tab.title === selected ? 'active' : '';
          return (
            <div
              key={tab.title}
              onClick={() => setSelected(tab.title)}
              className={active}
            >
              {tab.title} ({tab.questions.length})</div>
          );
        })}
      </>
    );
  } else {
    return null;
  }
};

export default QuestionsReviewModeNavTabs;
